module.exports = __webpack_public_path__ + "img/Large-Horizontal-Rectangular-Attachment-38.98cc4ecd.png";